import React from "react";

export default function GlobalReach() {
    return (
        <section className="pt-20 pb-20">
            <div className="container px-0">
                <img src="/global_reach.webp" alt="Tarif Overseas Headquarters" className="img-fluid" style={{ borderRadius:"15px" }} />
            </div>
        </section>
    );
}